import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
import * as actions from './actions'
import * as getters from './getters'
import aghCare from './modules/agh.care'
const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
    actions,
    getters,
    modules: {
        aghCare
    },
    strict: debug
})
